// extracted by mini-css-extract-plugin
export default {"container":"ExpertData_container__9XTcr","img":"ExpertData_img__yjTao","expertImgCircle":"ExpertData_expertImgCircle__qrdWX","bgCircle":"ExpertData_bgCircle__YJkpK"};